interface LegacyTicket {
  id: number;
  dateCreate: string;
  closingDate?: string;
  state: number;
  subject: string;
  deleted?: boolean;
  closed?: boolean;
  closedReason?: { label: string };
  supportEmployee?: { user: { username: string; id: string } };
}

interface Ticket {
  id: string;
  legacyId?: number;
  createdAt: string;
  creatorId: string;
  type: string;
  subject: string;
  criticity: number;
  priority: number;
  domainId: string;
  dateLastUpdate?: string;
  stateId: number;
  comment?: string;
  lastDunningDate?: string;
  dunningCount?: number;
  closingDate?: string;
  closedReasonId?: number;
  customerSatisfactionRating?: number;
  supportEmployeeId: string;
  associatedContactId?: string;
  appointmentsIds?: number[];
  notesIds?: number[];
  tasksIds?: number[];
  remindersIds?: number[];
  siteId?: string;
  dealId?: string;
  urlSupplierTicket?: string;
  supplierOfProductId?: string;
  productType?: string;
}

interface TicketState {
  id: number;
  name: string;
}

interface TicketClosedReason {
  id: number;
  label: string;
}

interface CreateTicketOptions {
  siteId?: string;
  domainId?: string;
  legacyDealId?: number;
  type: string;
  productType?: string;
  subject: string;
  supplierOfProductId?: string;
  associatedContactId?: string;
  criticity: number;
  priority: number;
  comment?: string;
  supportEmployeeId?: string;
  newContactLastname?: string;
  newContactFirstname?: string;
  newContactPhoneNumber?: string;
  newContactEmail?: string;
}

interface TicketSearchCriteria {
  global?: 1 | 0;
  withRating?: boolean;
  stateId?: number;
  supportEmployeeId?: string;
  domainId?: string;
  siteId?: string;
  priority?: number;
  criticity?: number;
  closed?: boolean;
  startDate?: string;
  endDate?: string;
}

enum TicketStates {
  a_traiter = 1,
  attente_retour_client = 2,
  attente_retour_fournisseur = 3,
  attente_retour_materiel = 4,
  attente_intervention = 5,
  standby = 6,
  intervention_a_prevoir = 7,
  en_cours_de_traitement = 8,
  attente_intervention_fournisseur = 9,
}

export default Ticket;
export { TicketSearchCriteria, TicketState, TicketStates, TicketClosedReason, LegacyTicket, CreateTicketOptions };
